import React, {useMemo} from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';

import {IGroupCompanyDto} from '../api/types';
import {EditGroupCompanyForm} from '../ui/forms/group-company-form';

export const useCompanyGroupInfoColumns = (
    tableData: IGroupCompanyDto[] | undefined,
    fetchData: () => Promise<void>
): IUseCustomTableArgs['columns'] =>
    useMemo(
        () => [
            {
                title: 'ИНН организации',
                dataIndex: 'inn',
                width: 400,
                render: (value: string, fields: IGroupCompanyDto) => (
                    <EditGroupCompanyForm
                        fields={fields}
                        value={value}
                        fetchData={fetchData}
                    />
                ),
            },
            {title: 'Сведения о гос. участии', dataIndex: 'statePart', render: (value) => <div>{value?.meaning}</div>},
        ],
        [tableData]
    );
